export default "__VITE_ASSET__BNZBbvzU__"